import { DeleteFilled, TeamOutlined } from '@ant-design/icons';
import { Card, Col, Row, Skeleton, Space, Tooltip, Typography } from 'antd';

import type {
  TemplatesType,
  TemplateType,
} from '@pages/Users/AccessRightsTab/types';
import '@pages/Users/AccessRightsTab/styles/Templates.desktop.scss';

const { Title, Text } = Typography;
const PF = 'access-rights-tab-templates';

const Template: TemplateType = ({
  onSelectTemplate,
  onDeleteTemplate,
  showDeleteTemplateButton,
  ...template
}) => (
  <Card
    className={`${PF}_template`}
    onClick={() => onSelectTemplate(template)}
    data-testid="rights-template-block"
  >
    <Row gutter={12} justify="space-between" align="bottom">
      <Col span={22}>
        <Space direction="vertical">
          <Space>
            <Text strong data-testid="rights-template-name">
              {template.Name}
            </Text>
            <TeamOutlined />
          </Space>
          <Text data-testid="rights-template-description">
            {template.Description}
          </Text>
        </Space>
      </Col>
      <Col span={2}>
        {showDeleteTemplateButton && (
          <Tooltip title="Удалить шаблон прав">
            <DeleteFilled
              className={`${PF}_icon`}
              onClick={(event) => {
                event.stopPropagation();
                onDeleteTemplate(template);
              }}
              data-testid="delete-rights-template"
            />
          </Tooltip>
        )}
      </Col>
    </Row>
  </Card>
);

export const Templates: TemplatesType = ({
  showTemplates,
  isLoading,
  templates,
  onSelectTemplate,
  onDeleteTemplate,
  showDeleteTemplateButton,
}) => {
  if (!showTemplates) {
    return <></>;
  }

  return (
    <div>
      <Title level={3} data-testid="rights-templates">
        Шаблоны прав
      </Title>
      <div className={`${PF}_container`}>
        {isLoading && <Skeleton active />}
        {templates.length === 0 && !isLoading && (
          <Card>
            <Text type="secondary">
              В организации еще не создано ни одного шаблона. Чтобы создать
              шаблон, выберите нужные права и нажмите кнопку "Создать шаблон
              прав" внизу страницы.
            </Text>
          </Card>
        )}
        {templates.length > 0 && (
          <Space className="templates-wrapper-component">
            {templates.map((template) => (
              <Template
                key={template.Id}
                {...template}
                onSelectTemplate={onSelectTemplate}
                onDeleteTemplate={onDeleteTemplate}
                showDeleteTemplateButton={showDeleteTemplateButton}
              />
            ))}
          </Space>
        )}
      </div>
    </div>
  );
};
